var cropper;

$(document).ready(function () {
    if($('.cropper').length == 0) {
        return true;
    }

    $(document).on('click', '#cropper-zoom-out', function(){cropper.zoom(-0.1);});
    $(document).on('click', '#cropper-zoom-in', function(){cropper.zoom(0.1);});
    $(document).on('click', '#modal-bootstrap #cancel', function(){destroyCropper();});

    initCropperModalWithCircle()
});

function initCropperModalWithCircle() {
    var resultImage = document.getElementById('resultImage');
    var image = document.getElementById('image');
    var input = document.getElementById('input');
    var cancelBtn = document.getElementById('cancel');
    var cropBtn = document.getElementById('crop');
    var $alert = $('.alert');
    var modal = $('#modal-bootstrap');

    var getRoundedCanvas = function (sourceCanvas) {
        if (!sourceCanvas) {
            return true;
        }
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var width = sourceCanvas.width;
        var height = sourceCanvas.height;

        canvas.width = width;
        canvas.height = height;
        context.imageSmoothingEnabled = true;
        context.drawImage(sourceCanvas, 0, 0, width, height);
        context.globalCompositeOperation = 'destination-in';
        context.beginPath();
        context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
        context.fill();
        return canvas;
    }

    cropBtn.addEventListener('click', function (e) {
        var croppedCanvas;
        var roundedCanvas;

        croppedCanvas = cropper.getCroppedCanvas({ width: 250, height: 250, fillColor: '#fff' });
        roundedCanvas = getRoundedCanvas(croppedCanvas);
        resultImage.src = roundedCanvas.toDataURL();
        $('#fileImage').val(croppedCanvas.toDataURL());
        destroyCropper();
    });

    cancelBtn.addEventListener('click', function (e) {
        destroyCropper();
    });

    input.addEventListener('change', function (e) {
        var files = e.target.files;

        var done = function (url) {
            input.value = '';
            image.src = url;
            $alert.hide();
            // modal.openModal();
            modal.modal('show');
            window.setTimeout(function(){
                cropper = new Cropper(image, {
                    fillColor: '#fff',
                    aspectRatio: 1,
                    preview: '.preview',
                });
            }, 250);


        };
        var reader;
        var file;

        if (files && files.length > 0) {
            file = files[0];

            if (URL) {
                done(URL.createObjectURL(file));
            } else if (FileReader) {
                reader = new FileReader();
                reader.onload = function (e) {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    });

}

function destroyCropper() {
    $('#modal-bootstrap').modal('hide');
    if(cropper){
        cropper.destroy();
        cropper = null;
    }
}